import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-table-container" }
const _hoisted_2 = { class: "is-flex is-align-items-center is-family-monospace" }
const _hoisted_3 = { class: "sha-cell" }
const _hoisted_4 = { class: "control is-flex is-align-items-center" }
const _hoisted_5 = { class: "has-text-centered mt-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_breadcrumb, {
      size: "is-large",
      separator: "has-succeeds-separator",
      "aria-label": "breadcrumbs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_breadcrumb_item, {
          tag: "a",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({name: 'device-list'})), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.devices')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_b_breadcrumb_item, { active: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('firmwares.title')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_table, {
        data: _ctx.rows,
        striped: "",
        loading: _ctx.loading,
        onClick: _ctx.handleRowClick,
        "sort-icon": "menu-up",
        "default-sort": "createdAt",
        "default-sort-direction": "desc",
        "group-field": "projectId",
        "group-sort": [{ field: 'projectId', order: 'asc' }],
        "group-options": { collapsible: true, defaultOpen: true, rowHeader: false }
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('firmwares.noneYet')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_b_table_column, {
            field: "sha256",
            sortable: "",
            label: _ctx.$t('firmwares.checksum')
          }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(props.row.sha256), 1)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "projectName",
            sortable: "",
            label: _ctx.$t('projects.title').slice(0,-1)
          }, {
            default: _withCtx((props) => [
              (props.row.projectId && (props.row.projectName || props.row.projectId))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'project-edit', params: { id: props.row.projectId } },
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.projectName || String(props.row.projectId)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(props.row.projectName || '—'), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "productId",
            sortable: "",
            label: _ctx.$t('firmwares.product')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.productId || '—'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "size",
            sortable: "",
            label: "Size"
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.formatSize(props.row.size)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_b_table_column, {
            field: "createdAt",
            sortable: "",
            label: _ctx.$t('firmwares.created')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.$d(new Date(props.row.createdAt), 'short')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "accessedAt",
            sortable: "",
            label: _ctx.$t('firmwares.lastAccessed')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.accessedAt ? _ctx.$d(new Date(props.row.accessedAt), 'short') : '—'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "downloadCount",
            sortable: "",
            label: _ctx.$t('firmwares.downloads')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.downloadCount ?? 0), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, { label: "Actions" }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_b_button, {
                  type: "is-primary",
                  size: "is-small",
                  "icon-left": "download",
                  title: _ctx.$t('global.download'),
                  "aria-label": "download",
                  class: "mr-2",
                  onClick: _withModifiers(($event: any) => (_ctx.downloadFirmware(props.row)), ["stop"])
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_b_button, {
                  type: "is-danger",
                  size: "is-small",
                  "icon-left": "delete",
                  title: _ctx.$t('global.delete'),
                  "aria-label": "delete",
                  onClick: _withModifiers(($event: any) => (_ctx.confirmRemove(props.row)), ["stop"])
                }, null, 8, ["title", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "loading", "onClick"])
    ])
  ]))
}